/*
validate-dotpay
*/

function containsOnlyDigits(t) {
	// const nums = new RegExp(/^\+?\d+$/);
	const nums = new RegExp(/^\+?[0-9]+$/);
	return Boolean(nums.test(t));
	// return (/^\+?\d+$/).test(t);
}

function hasStringLength(t, n) {
	const str = ((t || t === 0) && t.toString());
	return Boolean(str && str.length && str.length === n);
}

function hasStringLengthLessThan(t, n) {
	const str = ((t || t === 0) && t.toString());
	const L = str.length;
	return Boolean(str && (L < n));
}

function code(t) {
	return (hasStringLength(t, 6) && containsOnlyDigits(t));
}

function filterNonDigits(t) {
	/* does not allow exponential char 'e'*/
	const str = (t && t.toString());
	const nums = str && str.replace(/[^0-9]/g, '');
	return nums;
}

function restrictToLength(t, n) {
	return ((t && t.substring(0, n)) || null);
}
export default {
	code(t) {
		return code(t);
	},
	containsOnlyDigits(t) {
		return containsOnlyDigits(t);
	},
	hasStringLengthLessThan(t, n) {
		return hasStringLengthLessThan(t, n);
	},
	filterAwayNotValid(t) {
		const digitsAsString = filterNonDigits(t);
		const limited = restrictToLength(digitsAsString, 6);
		const num = parseInt(limited, 10);
		// return restrictToLength(digitsAsString, 6);
		return num;
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/validate-dotpay.js